import { PageContainer } from 'src/component/page-container/page-container'
import { useMyStartedProgrammes, useProgrammes } from 'src/hook/use-programmes'
import { ProgrammeList } from 'src/screen/programme/programme-list'

export const ProgrammeListScreen = (): React.ReactElement => {
  const { data: programmes = [], isLoading: isLoadingProgrammes } = useProgrammes()
  const { data: startedProgrammes = [], isLoading: isLoadingStartedProgrammes } = useMyStartedProgrammes()

  const isLoading = isLoadingProgrammes || isLoadingStartedProgrammes

  if (isLoading) {
    return <div>Loading...</div>
  }

  if (programmes.length === 0) {
    return <div>Currently there are no available programmes.</div>
  }

  return (
    <PageContainer>
      <div className="mt-5">
        <ProgrammeList programmes={programmes} startedProgrammes={startedProgrammes} />
      </div>
    </PageContainer>
  )
}
